
<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
    data-icon="PullRightOutlined">
    <path
      d="M1.014 5v14a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0Zm18.56 6.043H8.43a1 1 0 1 0 0 2h11.186l-4.67 4.67a1 1 0 0 0 1.413 1.415l5.65-5.65.007.008.71-.711a1 1 0 0 0 .004-1.41l-.714-.723-.008.008L16.358 5a1 1 0 1 0-1.413 1.414l4.629 4.629Z"
      fill="currentColor"></path>
  </svg>
</template>
